export default __webpack_public_path__ + "static/usda-logo-reverse@1x-72a1df1b7bb4925434015ae97291e029.png";